/**
 * --------------------------------------------------
 * components/PageNavigation.ts
 * Page Navigation
 * --------------------------------------------------
*/

import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { AccordionContainer } from '../Accordion/AccordionContainer';

@Component
export class PageNavigation extends ThemeComponent {
    @Ref({required: false}) navigationLinks!: HTMLAnchorElement[];
    //changeOpen
    init() {
        if (this.navigationLinks) {
            for (const link of this.navigationLinks) {
                // If the anchor link is an accordion section
                // open it
                link.addEventListener('click', () => {
                    const href = link.getAttribute("href");
                    const anchorTarget = document.querySelector(`${href}`);
                    const anchorType = anchorTarget?.nodeName;
                    if (anchorType == 'ACCORDION-CONTAINER') {
                        const accordion = anchorTarget as AccordionContainer;
                        accordion.open();
                    }
                });
            }
        }
    }
}
